import React from "react";
import Styles from "./PasswordChangedModal.module.scss";
import { Modal, Space, Text, Button } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const PasswordChangedModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  changedSuccess: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightNormal,
    textAlign: variables.alignCenter,
    display: variables.dBlock,
  },
  button: {
    border: `1px solid ${variables.grey4}`,
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  modalContent: { width: variables.fullWidth },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
};

export default function PasswordChangedModal({ open }) {
  const navigate = useNavigate();
  const intl = useIntl();
  const backToLogin = () => {
    navigate("/login");
  };

  return (
    <Modal
      maskClosable={false}
      maskStyle={PasswordChangedModalStyles.modalMaskStyle}
      className={Styles["edged-modal"]}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <Space
        direction="vertical"
        align="center"
        style={PasswordChangedModalStyles.modalContent}
      >
        <img src={"/resetPassSuccess.svg"} alt="pass-changed" />
        <Text style={PasswordChangedModalStyles.changed}>
          {getLocalizedMessage(intl, "login.passwordChanged")}
        </Text>
        <Text style={PasswordChangedModalStyles.changedSuccess}>
          {getLocalizedMessage(intl, "login.passwordChangedSuccess")}
        </Text>
        <Button
          onClick={backToLogin}
          type="dashed"
          style={PasswordChangedModalStyles.button}
          icon={<ArrowLeftOutlined />}
        >
          {getLocalizedMessage(intl, "login.backToLogin")}
        </Button>
      </Space>
    </Modal>
  );
}
